import { render, staticRenderFns } from "./inviteSetting.vue?vue&type=template&id=3da456a5&scoped=true"
import script from "./inviteSetting.vue?vue&type=script&lang=js"
export * from "./inviteSetting.vue?vue&type=script&lang=js"
import style0 from "./inviteSetting.vue?vue&type=style&index=0&id=3da456a5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da456a5",
  null
  
)

export default component.exports